export default "__VITE_ASSET__Cg88AYb7__"